import { createReducer, on } from '@ngrx/store';
import { quizQuestionActions } from '../actions/quiz-question.actions';
import { QuizQuestion } from '../models';

interface QuizQuestionEntry {
    loaded: boolean | null;
    loading: boolean;
    quizQuestion: QuizQuestion | null;
    error: number | null;
}
export interface QuizQuestionState {
    saving: boolean;
    saved: boolean;
    createdId: string | null;
    entries: Record<string, QuizQuestionEntry>;
}

export const initialState: QuizQuestionState = {
    saving: false,
    saved: false,
    createdId: null,
    entries: {},
};

export const quizQuestionReducer = createReducer(
    initialState,
    // Get
    on(
        quizQuestionActions.getQuizQuestion,
        (state, { id }): QuizQuestionState => ({
            ...state,
            entries: {
                ...state.entries,
                [id]: { loaded: null, loading: true, quizQuestion: null, error: null },
            },
        }),
    ),
    on(
        quizQuestionActions.getQuizQuestionSuccess,
        (state, { payload }): QuizQuestionState => ({
            ...state,
            entries: {
                ...state.entries,
                [payload.id]: { loaded: true, loading: false, quizQuestion: payload, error: null },
            },
        }),
    ),
    on(
        quizQuestionActions.getQuizQuestionError,
        (state, { id, code }): QuizQuestionState => ({
            ...state,
            entries: {
                ...state.entries,
                [id]: { loaded: false, loading: false, quizQuestion: null, error: code },
            },
        }),
    ),
    // Create
    on(
        quizQuestionActions.createQuizQuestion,
        (state): QuizQuestionState => ({
            ...state,
            saving: true,
            saved: false,
        }),
    ),
    on(
        quizQuestionActions.createQuizQuestionSuccess,
        (state, { payload }): QuizQuestionState => ({
            ...state,
            saving: false,
            saved: true,
            createdId: payload.id,
            entries: {
                ...state.entries,
                [payload.id]: { loaded: true, loading: false, quizQuestion: payload, error: null },
            },
        }),
    ),
    on(
        quizQuestionActions.createQuizQuestionError,
        (state): QuizQuestionState => ({
            ...state,
            saving: false,
            saved: false,
        }),
    ),
    // Update
    on(
        quizQuestionActions.updateQuizQuestion,
        (state): QuizQuestionState => ({
            ...state,
            saving: true,
            saved: false,
        }),
    ),
    on(
        quizQuestionActions.updateQuizQuestionSuccess,
        (state, { payload }): QuizQuestionState => ({
            ...state,
            saving: false,
            saved: true,
            entries: {
                ...state.entries,
                [payload.id]: { loaded: true, loading: false, quizQuestion: payload, error: null },
            },
        }),
    ),
    on(
        quizQuestionActions.updateQuizQuestionError,
        (state): QuizQuestionState => ({
            ...state,
            saving: false,
            saved: false,
        }),
    ),
    // Delete
    on(
        quizQuestionActions.deleteQuizQuestion,
        (state): QuizQuestionState => ({
            ...state,
            saving: true,
            saved: false,
        }),
    ),
    on(quizQuestionActions.deleteQuizQuestionSuccess, (state, { id }): QuizQuestionState => {
        const entries = { ...state.entries };
        delete entries[id];

        return {
            ...state,
            saving: false,
            saved: true,
            entries,
        };
    }),
    on(
        quizQuestionActions.deleteQuizQuestionError,
        (state): QuizQuestionState => ({
            ...state,
            saving: false,
            saved: false,
        }),
    ),
    // Clear
    on(quizQuestionActions.clear, (): QuizQuestionState => ({ ...initialState })),
);
